import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { TenantUserList } from '../../_objects/user';
import { TenantUserService } from '../http-api/tenant-user.service';
import { filter, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class UsersStateService {
  private usersSubject$ = new BehaviorSubject<TenantUserList[]>([]);
  public users$ = this.usersSubject$.asObservable();

  private isFirstAccessSubject = new BehaviorSubject<boolean>(false);
  isFirstAccess$ = this.isFirstAccessSubject.asObservable();

  constructor(private usersService: TenantUserService) {
  }

  public fetchAndUpdate() {
    this.usersService
      .getUsers()
      .pipe(filter(users => users.length != 0))
      .subscribe(data => this.usersSubject$.next(data));
  }

  public selectUserById(userId: string): Observable<TenantUserList | null> {
    return this.users$
      .pipe(map(users => users.find(user => user.id == userId)));
  }

  setIsFirstAccess(value: boolean) {
    this.isFirstAccessSubject.next(value);
  }

}
